import { ModelBase } from 'store/model-base';

export class WatchesPairEligibilityRequestId extends ModelBase {
    public static storeName: string = 'watchesPairEligibilityRequestId';

    public requestId: string;
    public eligibilityStatus?: string;
}
